var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInterfaceNumberPad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 332,
    height: 352,
    viewBox: "0 0 332 352",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "interface_number_pad",
    transform: "translate(-26 -726)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ETAPE",
    transform: "translate(29 725.85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1258",
    "data-name": "Rectangle 1258",
    transform: "translate(0 25.15)",
    fill: "none",
    stroke: "#51aabc",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 326,
    height: 324,
    rx: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: -1.5,
    width: 329,
    height: 327,
    rx: 25.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Component_1_4",
    "data-name": "Component 1 \\u2013 4",
    transform: "translate(100 0.15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161",
    "data-name": "Rectangle 161",
    width: 126,
    height: 41,
    rx: 20.5,
    fill: "#51aabc"
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\xE9tape",
    transform: "translate(20.174 31)",
    fill: "#fff",
    fontSize: 31,
    fontFamily: "FredokaOne-Regular, Fredoka One"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xE9tape")))), /*#__PURE__*/React.createElement("g", {
    id: "number_7",
    transform: "translate(61 977)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "ellipse_7",
    cx: 33,
    cy: 33,
    r: 33,
    stroke: "#51aabc",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "number_7-2",
    "data-name": "number_7",
    d: "M7.278-30.012q2.87,0,3.362,1.558a7.353,7.353,0,0,1,.246,2.3,10.663,10.663,0,0,1-1.066,4.08,36.448,36.448,0,0,1-2.562,4.818q-1.5,2.378-3.013,4.8Q.635-6.6.635-3.034A7.813,7.813,0,0,1,.554-1.7a2.386,2.386,0,0,1-.41.9A1.69,1.69,0,0,1-.943-.164,10.262,10.262,0,0,1-3.013,0,10.262,10.262,0,0,1-5.084-.164,1.654,1.654,0,0,1-6.17-.82a2.276,2.276,0,0,1-.39-.923,10.83,10.83,0,0,1-.061-1.373,17.85,17.85,0,0,1,.9-5.474,26.091,26.091,0,0,1,2.173-5.022Q-2.276-15.826-1-17.691t2.173-3.2a4.36,4.36,0,0,0,.9-1.865h-9.35a5.148,5.148,0,0,1-2.378-.41,2.015,2.015,0,0,1-.984-1.189,6.99,6.99,0,0,1-.246-2.05,6.99,6.99,0,0,1,.246-2.05A1.723,1.723,0,0,1-9.86-29.52a4.815,4.815,0,0,1,2.378-.492Z",
    transform: "translate(33 48)",
    fill: "#51aabc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "padlock_7",
    d: "M30.691,15.688H28.639V11.695a8.209,8.209,0,1,0-16.417-.111v4.1H10.17A3.43,3.43,0,0,0,6.75,19.1v16.42a3.43,3.43,0,0,0,3.42,3.42H30.691a3.43,3.43,0,0,0,3.42-3.42V19.108a3.43,3.43,0,0,0-3.42-3.42Zm-9.063,10.67v5.883a1.226,1.226,0,0,1-1.137,1.231,1.2,1.2,0,0,1-1.257-1.2V26.358a2.736,2.736,0,1,1,2.394,0Zm4.617-10.671H14.616v-4.1a5.814,5.814,0,1,1,11.628,0Z",
    transform: "translate(12.569 11.841)",
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SUCCESS_7",
    transform: "translate(49.543 -3.457)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    transform: "translate(0.457 0.457)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "star_5_",
    "data-name": "star (5)",
    d: "M24.359,9.81a1.311,1.311,0,0,0-1.117-.94L16.192,8.2,13.4,1.322a1.273,1.273,0,0,0-2.387,0L8.23,8.2l-7.05.674a1.314,1.314,0,0,0-1.116.94,1.414,1.414,0,0,0,.38,1.453l5.328,4.923L4.2,23.476a1.4,1.4,0,0,0,.5,1.412,1.236,1.236,0,0,0,1.426.066l6.08-3.828,6.078,3.828a1.239,1.239,0,0,0,1.427-.066,1.406,1.406,0,0,0,.5-1.412L18.65,16.185l5.328-4.922A1.416,1.416,0,0,0,24.359,9.81Zm0,0",
    transform: "translate(4.746 4.137)",
    fill: "#f5bd3f",
    opacity: 0.998
  })), /*#__PURE__*/React.createElement("g", {
    id: "FAIL_7",
    transform: "translate(49.543 -3.457)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_41-2",
    "data-name": "Ellipse 41",
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    transform: "translate(0.457 0.457)",
    fill: "#ce6f3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11241",
    "data-name": "Path 11241",
    d: "M-2.2-16.509.465-13.824a2.359,2.359,0,0,1,.863,1.474,2.32,2.32,0,0,1-.863,1.462A2.366,2.366,0,0,1-1-10.036,2.357,2.357,0,0,1-2.46-10.9L-5.1-13.56-7.758-10.9a2.356,2.356,0,0,1-1.45.863,2.4,2.4,0,0,1-1.462-.851,2.312,2.312,0,0,1-.875-1.462,2.359,2.359,0,0,1,.863-1.474l2.661-2.685-2.661-2.685a2.359,2.359,0,0,1-.863-1.474,2.351,2.351,0,0,1,.875-1.474,2.4,2.4,0,0,1,1.462-.863,2.356,2.356,0,0,1,1.45.863L-5.1-19.457l2.637-2.685A2.357,2.357,0,0,1-1-23.005a2.357,2.357,0,0,1,1.462.863,2.359,2.359,0,0,1,.863,1.474,2.359,2.359,0,0,1-.863,1.474Z",
    transform: "translate(22.066 33.478)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "number_6",
    transform: "translate(257 885)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "ellipse_6",
    cx: 33,
    cy: 33,
    r: 33,
    stroke: "#51aabc",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "number_6-2",
    "data-name": "number_6",
    d: "M10.455-9.184A9.113,9.113,0,0,1,7.483-2.255,10.138,10.138,0,0,1,.287.533q-5.33,0-8.036-3.424a13.82,13.82,0,0,1-2.706-8.836A19.528,19.528,0,0,1-6.006-24.8q4.449-5.248,12.157-5.248a5,5,0,0,1,2.275.389,1.952,1.952,0,0,1,.963,1.169,6.646,6.646,0,0,1,.246,1.968,6.93,6.93,0,0,1-.2,1.886,3.239,3.239,0,0,1-.492,1.066,1.6,1.6,0,0,1-.82.533A7.979,7.979,0,0,1,5.74-22.8a9.466,9.466,0,0,0-3.259.574A7.434,7.434,0,0,0,0-20.828a7.526,7.526,0,0,0-2.214,3.034l-.2.574a7.214,7.214,0,0,1,3.034-.7,9.85,9.85,0,0,1,6.95,2.686,8.094,8.094,0,0,1,2.885,6.05ZM.123-6.191q3.157,0,3.157-2.747A2.633,2.633,0,0,0,2.563-10.7a2.9,2.9,0,0,0-2.3-.82,3.492,3.492,0,0,0-2.419.759A2.125,2.125,0,0,0-3-9.223a5.219,5.219,0,0,0,.1,1.189,3.523,3.523,0,0,0,.389.9Q-1.927-6.191.123-6.191Z",
    transform: "translate(32 48)",
    fill: "#51aabc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "padlock_6",
    d: "M30.691,15.688H28.639V11.695a8.209,8.209,0,1,0-16.417-.111v4.1H10.17A3.43,3.43,0,0,0,6.75,19.1v16.42a3.43,3.43,0,0,0,3.42,3.42H30.691a3.43,3.43,0,0,0,3.42-3.42V19.108a3.43,3.43,0,0,0-3.42-3.42Zm-9.063,10.67v5.883a1.226,1.226,0,0,1-1.137,1.231,1.2,1.2,0,0,1-1.257-1.2V26.358a2.736,2.736,0,1,1,2.394,0Zm4.617-10.671H14.616v-4.1a5.814,5.814,0,1,1,11.628,0Z",
    transform: "translate(12.569 11.841)",
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SUCCESS_6",
    transform: "translate(48.543 -3.457)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_41-3",
    "data-name": "Ellipse 41",
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    transform: "translate(0.457 0.457)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "star_5_2",
    "data-name": "star (5)",
    d: "M24.359,9.81a1.311,1.311,0,0,0-1.117-.94L16.192,8.2,13.4,1.322a1.273,1.273,0,0,0-2.387,0L8.23,8.2l-7.05.674a1.314,1.314,0,0,0-1.116.94,1.414,1.414,0,0,0,.38,1.453l5.328,4.923L4.2,23.476a1.4,1.4,0,0,0,.5,1.412,1.236,1.236,0,0,0,1.426.066l6.08-3.828,6.078,3.828a1.239,1.239,0,0,0,1.427-.066,1.406,1.406,0,0,0,.5-1.412L18.65,16.185l5.328-4.922A1.416,1.416,0,0,0,24.359,9.81Zm0,0",
    transform: "translate(4.746 4.137)",
    fill: "#f5bd3f",
    opacity: 0.998
  })), /*#__PURE__*/React.createElement("g", {
    id: "FAIL_6",
    transform: "translate(48.543 -3.457)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_41-4",
    "data-name": "Ellipse 41",
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    transform: "translate(0.457 0.457)",
    fill: "#ce6f3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11241-2",
    "data-name": "Path 11241",
    d: "M-2.2-16.509.465-13.824a2.359,2.359,0,0,1,.863,1.474,2.32,2.32,0,0,1-.863,1.462A2.366,2.366,0,0,1-1-10.036,2.357,2.357,0,0,1-2.46-10.9L-5.1-13.56-7.758-10.9a2.356,2.356,0,0,1-1.45.863,2.4,2.4,0,0,1-1.462-.851,2.312,2.312,0,0,1-.875-1.462,2.359,2.359,0,0,1,.863-1.474l2.661-2.685-2.661-2.685a2.359,2.359,0,0,1-.863-1.474,2.351,2.351,0,0,1,.875-1.474,2.4,2.4,0,0,1,1.462-.863,2.356,2.356,0,0,1,1.45.863L-5.1-19.457l2.637-2.685A2.357,2.357,0,0,1-1-23.005a2.357,2.357,0,0,1,1.462.863,2.359,2.359,0,0,1,.863,1.474,2.359,2.359,0,0,1-.863,1.474Z",
    transform: "translate(22.066 33.478)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "number_4",
    transform: "translate(61 885)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "ellipse_4",
    cx: 33,
    cy: 33,
    r: 33,
    stroke: "#51aabc",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "number_4-2",
    "data-name": "number_4",
    d: "M3.649-29.069a1.778,1.778,0,0,1,1.128-.8,7.923,7.923,0,0,1,2.091-.226,6.565,6.565,0,0,1,2.07.267,1.9,1.9,0,0,1,1.107.861,3.087,3.087,0,0,1,.389,1.086,12.473,12.473,0,0,1,.062,1.435v22.8a5.4,5.4,0,0,1-.389,2.358,1.928,1.928,0,0,1-1.189,1A6.858,6.858,0,0,1,6.93-.042a6.93,6.93,0,0,1-1.887-.2A3.239,3.239,0,0,1,3.977-.738a1.6,1.6,0,0,1-.533-.82A6.855,6.855,0,0,1,3.2-3.69v-5H-7.913q-2.87,0-3.4-1.558a6.1,6.1,0,0,1-.2-1.763,7.95,7.95,0,0,1,.123-1.64l3.4-13.735q.246-.943.431-1.435a2.3,2.3,0,0,1,.738-.943,2.167,2.167,0,0,1,1.414-.451,7.036,7.036,0,0,1,1.886.287q2.87.779,2.87,2.624a6.975,6.975,0,0,1-.287,1.722.315.315,0,0,0-.041.123l-2.5,10H3.2V-26.65a11.363,11.363,0,0,1,.061-1.394,2.926,2.926,0,0,1,.388-1.025Z",
    transform: "translate(32 48)",
    fill: "#51aabc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "padlock_4",
    d: "M30.691,15.688H28.639V11.695a8.209,8.209,0,1,0-16.417-.111v4.1H10.17A3.43,3.43,0,0,0,6.75,19.1v16.42a3.43,3.43,0,0,0,3.42,3.42H30.691a3.43,3.43,0,0,0,3.42-3.42V19.108a3.43,3.43,0,0,0-3.42-3.42Zm-9.063,10.67v5.883a1.226,1.226,0,0,1-1.137,1.231,1.2,1.2,0,0,1-1.257-1.2V26.358a2.736,2.736,0,1,1,2.394,0Zm4.617-10.671H14.616v-4.1a5.814,5.814,0,1,1,11.628,0Z",
    transform: "translate(12.569 11.712)",
    fill: "#c3c3c3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "number_5",
    transform: "translate(159 885)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "ellipse_5",
    cx: 33,
    cy: 33,
    r: 33,
    stroke: "#51aabc",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "number_5-2",
    "data-name": "number_5",
    d: "M-4.469-30.135l6.232.041H5.617a11.836,11.836,0,0,1,1.435.062,3.305,3.305,0,0,1,1.066.39q1.107.574,1.107,3.28,0,2.46-1.025,2.993a2.944,2.944,0,0,1-1,.389,10.378,10.378,0,0,1-1.332.062h-7.18q-.082.492-.41,3.116a8.906,8.906,0,0,1,1.435-.082,9.977,9.977,0,0,1,7.011,2.931A9.472,9.472,0,0,1,9.84-9.778a10.135,10.135,0,0,1-2.952,7.3A9.792,9.792,0,0,1-.451.574,12.7,12.7,0,0,1-7.339-1.353a6.493,6.493,0,0,1-1.025-.779l-.328-.287a3.622,3.622,0,0,1-1.558-2.46A4.29,4.29,0,0,1-8.733-7.544,3.383,3.383,0,0,1-6.355-8.9,4.693,4.693,0,0,1-3.608-7.585a3.233,3.233,0,0,0,2.563.861A4,4,0,0,0,1.661-7.5a2.724,2.724,0,0,0,.881-2.152,2.675,2.675,0,0,0-.964-2.173,3.34,3.34,0,0,0-2.193-.8,2.66,2.66,0,0,0-1.968.738,3.448,3.448,0,0,1-2.235.943A5.617,5.617,0,0,1-7.4-11.726a8.455,8.455,0,0,1-1.907-1.25,1.439,1.439,0,0,1-.451-1q0-.533.82-6.6t.861-6.314a5.028,5.028,0,0,1,.287-.861,5.332,5.332,0,0,1,.59-1.113,3.066,3.066,0,0,1,1.066-.881,3.426,3.426,0,0,1,1.665-.39Z",
    transform: "translate(33 48)",
    fill: "#51aabc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "padlock_5",
    d: "M30.691,15.688H28.639V11.695a8.209,8.209,0,1,0-16.417-.111v4.1H10.17A3.43,3.43,0,0,0,6.75,19.1v16.42a3.43,3.43,0,0,0,3.42,3.42H30.691a3.43,3.43,0,0,0,3.42-3.42V19.108a3.43,3.43,0,0,0-3.42-3.42Zm-9.063,10.67v5.883a1.226,1.226,0,0,1-1.137,1.231,1.2,1.2,0,0,1-1.257-1.2V26.358a2.736,2.736,0,1,1,2.394,0Zm4.617-10.671H14.616v-4.1a5.814,5.814,0,1,1,11.628,0Z",
    transform: "translate(12.569 12.06)",
    fill: "#c3c3c3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "number_1",
    transform: "translate(61 793)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "ellipse_1",
    cx: 33,
    cy: 33,
    r: 33,
    stroke: "#51aabc",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "number_1-2",
    "data-name": "number_1",
    d: "M.594-29.028a3.232,3.232,0,0,1,2.317-1.066,7.224,7.224,0,0,1,1.947.2,3.57,3.57,0,0,1,1.066.471,1.715,1.715,0,0,1,.574.882,8.37,8.37,0,0,1,.2,2.173V-3.526a11.911,11.911,0,0,1-.062,1.414,3.285,3.285,0,0,1-.389,1.087Q5.678.082,3.054.082.512.082-.1-.984A3.266,3.266,0,0,1-.49-2.111a13.551,13.551,0,0,1-.061-1.5V-18.245l-.533.492a5.121,5.121,0,0,1-2.87,1.271,3.534,3.534,0,0,1-2.481-1.435,4.089,4.089,0,0,1-1.292-2.542,3.537,3.537,0,0,1,1.476-2.419L.472-28.946Z",
    transform: "translate(31 48)",
    fill: "#51aabc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "padlock_1",
    d: "M30.691,15.688H28.639V11.695a8.209,8.209,0,1,0-16.417-.111v4.1H10.17A3.43,3.43,0,0,0,6.75,19.1v16.42a3.43,3.43,0,0,0,3.42,3.42H30.691a3.43,3.43,0,0,0,3.42-3.42V19.108a3.43,3.43,0,0,0-3.42-3.42Zm-9.063,10.67v5.883a1.226,1.226,0,0,1-1.137,1.231,1.2,1.2,0,0,1-1.257-1.2V26.358a2.736,2.736,0,1,1,2.394,0Zm4.617-10.671H14.616v-4.1a5.814,5.814,0,1,1,11.628,0Z",
    transform: "translate(12.569 11.841)",
    fill: "#c3c3c3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "number_2",
    transform: "translate(159 793)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "ellipse_2",
    cx: 33,
    cy: 33,
    r: 33,
    stroke: "#51aabc",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "number_2-2",
    "data-name": "number_2",
    d: "M8.261-7.216a5.367,5.367,0,0,1,2.4.39,1.953,1.953,0,0,1,.964,1.189,7.3,7.3,0,0,1,.246,2.091,6.565,6.565,0,0,1-.271,2.07A1.711,1.711,0,0,1,10.721-.41,5.378,5.378,0,0,1,8.179.082H-7.852a3.408,3.408,0,0,1-2.542-1.107A3.607,3.607,0,0,1-11.46-3.608,6.277,6.277,0,0,1-9.922-7.687a14.755,14.755,0,0,1,3.71-3.2q2.173-1.332,4.346-2.624a16.821,16.821,0,0,0,3.71-2.932,5.042,5.042,0,0,0,1.537-3.485A2.945,2.945,0,0,0,3.1-20.972a4.632,4.632,0,0,0-.636-1.107,3.246,3.246,0,0,0-1.086-.8,4.659,4.659,0,0,0-2.05-.369,3.112,3.112,0,0,0-2.275.963,3.4,3.4,0,0,0-1.087,1.906l-.164.943v.246a10.9,10.9,0,0,1-.062,1.353,2.926,2.926,0,0,1-.39,1.025q-.615.984-3.2.984-2.87,0-3.4-1.558a7.665,7.665,0,0,1-.2-2.091A11.107,11.107,0,0,1-8.4-27.121,10.263,10.263,0,0,1-.41-30.5a10.268,10.268,0,0,1,8.016,3.42,11.361,11.361,0,0,1,3.075,7.81,9.931,9.931,0,0,1-1.025,4.428A10.721,10.721,0,0,1,7.2-11.48,19.327,19.327,0,0,1,1.783-7.831l-1.025.41v.2Z",
    transform: "translate(33 48)",
    fill: "#51aabc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "padlock_2",
    d: "M30.691,15.688H28.639V11.695a8.209,8.209,0,1,0-16.417-.111v4.1H10.17A3.43,3.43,0,0,0,6.75,19.1v16.42a3.43,3.43,0,0,0,3.42,3.42H30.691a3.43,3.43,0,0,0,3.42-3.42V19.108a3.43,3.43,0,0,0-3.42-3.42Zm-9.063,10.67v5.883a1.226,1.226,0,0,1-1.137,1.231,1.2,1.2,0,0,1-1.257-1.2V26.358a2.736,2.736,0,1,1,2.394,0Zm4.617-10.671H14.616v-4.1a5.814,5.814,0,1,1,11.628,0Z",
    transform: "translate(12.774 11.629)",
    fill: "#c3c3c3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "number_3",
    transform: "translate(257 793)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "ellipse_3",
    cx: 33,
    cy: 33,
    r: 33,
    stroke: "#51aabc",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "number_3-2",
    "data-name": "number_3",
    d: "M-.082-30.5a10.836,10.836,0,0,1,7.954,2.87,8.865,8.865,0,0,1,2.911,6.458,5.4,5.4,0,0,1-3.2,5.187v.287a7.117,7.117,0,0,1,1.209.881,8.331,8.331,0,0,1,1.292,1.332,6.2,6.2,0,0,1,1.353,3.936,9.166,9.166,0,0,1-3.28,7.236A12.115,12.115,0,0,1-.082.533a12,12,0,0,1-8.2-2.87,10.251,10.251,0,0,1-2.173-2.911,7.093,7.093,0,0,1-.451-1.066l-.082-.41a7.352,7.352,0,0,1-.451-2.214q0-2.378,4.018-2.378a3.894,3.894,0,0,1,2.173.41,4.447,4.447,0,0,1,1.23,2.132A3.262,3.262,0,0,0-1.763-6.806,5.7,5.7,0,0,0-.041-6.56a4.831,4.831,0,0,0,3.2-.882A2.586,2.586,0,0,0,4.182-9.43a2.487,2.487,0,0,0-1-1.948A3.588,3.588,0,0,0,.8-12.218,13.672,13.672,0,0,1-1.066-12.3a3.267,3.267,0,0,1-1.066-.41q-1.107-.533-1.107-3.157,0-2.87,1.517-3.4a8.154,8.154,0,0,1,2.132-.2q3.116,0,3.116-1.6a2.266,2.266,0,0,0-.82-1.64A3.171,3.171,0,0,0,.43-23.486,4.666,4.666,0,0,0-1.886-23a2.358,2.358,0,0,0-1.066.984l-.246.492a2.956,2.956,0,0,1-2.7,2.049,4.46,4.46,0,0,1-2.255-.738q-2.05-1.189-2.05-2.747a9.5,9.5,0,0,1,.943-2.788,7.6,7.6,0,0,1,.9-1.291,8.694,8.694,0,0,1,1.7-1.62A10.035,10.035,0,0,1-3.957-29.93,12.335,12.335,0,0,1-.082-30.5Z",
    transform: "translate(33 48)",
    fill: "#51aabc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "padlock_3",
    d: "M30.691,15.688H28.639V11.695a8.209,8.209,0,1,0-16.417-.111v4.1H10.17A3.43,3.43,0,0,0,6.75,19.1v16.42a3.43,3.43,0,0,0,3.42,3.42H30.691a3.43,3.43,0,0,0,3.42-3.42V19.108a3.43,3.43,0,0,0-3.42-3.42Zm-9.063,10.67v5.883a1.226,1.226,0,0,1-1.137,1.231,1.2,1.2,0,0,1-1.257-1.2V26.358a2.736,2.736,0,1,1,2.394,0Zm4.617-10.671H14.616v-4.1a5.814,5.814,0,1,1,11.628,0Z",
    transform: "translate(12.569 11.841)",
    fill: "#c3c3c3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "number_8",
    transform: "translate(159 977)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "ellipse_8",
    cx: 33,
    cy: 33,
    r: 33,
    stroke: "#51aabc",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "number_8-2",
    "data-name": "number_8",
    d: "M10.906-9.635a9.193,9.193,0,0,1-3.342,7.4A11.441,11.441,0,0,1,0,.574,11.49,11.49,0,0,1-7.564-2.214a9.178,9.178,0,0,1-3.342-7.421,7.169,7.169,0,0,1,.84-3.342A8.4,8.4,0,0,1-8.4-15.334l.861-.779q-.287-.246-.7-.656a7.584,7.584,0,0,1-1.087-1.783A6.374,6.374,0,0,1-10-21.4a8.4,8.4,0,0,1,3.03-6.644A10.452,10.452,0,0,1,.082-30.668,10.06,10.06,0,0,1,7.052-28,8.761,8.761,0,0,1,10-21.2a5.872,5.872,0,0,1-.6,2.5,7.467,7.467,0,0,1-1.2,1.931l-.615.656a10.544,10.544,0,0,1,.922.841,10.957,10.957,0,0,1,1.476,2.235,7.005,7.005,0,0,1,.923,3.4ZM2.747-21.443a2.182,2.182,0,0,0-.7-1.538A2.761,2.761,0,0,0-.021-23.7a2.666,2.666,0,0,0-2.03.7,2.2,2.2,0,0,0-.656,1.537,2.241,2.241,0,0,0,.718,1.579,2.729,2.729,0,0,0,2.05.738,2.591,2.591,0,0,0,2.009-.738A2.283,2.283,0,0,0,2.747-21.443Zm-5.453,14.1a3.629,3.629,0,0,0,2.747.984,3.492,3.492,0,0,0,2.706-.984,3.08,3.08,0,0,0,.9-2.111,3.046,3.046,0,0,0-.923-2.112A3.532,3.532,0,0,0,.018-12.55a3.645,3.645,0,0,0-2.727.964,2.967,2.967,0,0,0-.943,2.111,3.035,3.035,0,0,0,.946,2.136Z",
    transform: "translate(33 48)",
    fill: "#51aabc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "padlock_8",
    d: "M30.691,15.688H28.639V11.695a8.209,8.209,0,1,0-16.417-.111v4.1H10.17A3.43,3.43,0,0,0,6.75,19.1v16.42a3.43,3.43,0,0,0,3.42,3.42H30.691a3.43,3.43,0,0,0,3.42-3.42V19.108a3.43,3.43,0,0,0-3.42-3.42Zm-9.063,10.67v5.883a1.226,1.226,0,0,1-1.137,1.231,1.2,1.2,0,0,1-1.257-1.2V26.358a2.736,2.736,0,1,1,2.394,0Zm4.617-10.671H14.616v-4.1a5.814,5.814,0,1,1,11.628,0Z",
    transform: "translate(13.569 11.84)",
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SUCCESS_8",
    transform: "translate(53.543 -3.457)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_41-5",
    "data-name": "Ellipse 41",
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    transform: "translate(0.457 0.457)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "star_5_3",
    "data-name": "star (5)",
    d: "M24.359,9.81a1.311,1.311,0,0,0-1.117-.94L16.192,8.2,13.4,1.322a1.273,1.273,0,0,0-2.387,0L8.23,8.2l-7.05.674a1.314,1.314,0,0,0-1.116.94,1.414,1.414,0,0,0,.38,1.453l5.328,4.923L4.2,23.476a1.4,1.4,0,0,0,.5,1.412,1.236,1.236,0,0,0,1.426.066l6.08-3.828,6.078,3.828a1.239,1.239,0,0,0,1.427-.066,1.406,1.406,0,0,0,.5-1.412L18.65,16.185l5.328-4.922A1.416,1.416,0,0,0,24.359,9.81Zm0,0",
    transform: "translate(4.746 4.137)",
    fill: "#f5bd3f",
    opacity: 0.998
  })), /*#__PURE__*/React.createElement("g", {
    id: "FAIL_8",
    transform: "translate(53.543 -3.457)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_41-6",
    "data-name": "Ellipse 41",
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    transform: "translate(0.457 0.457)",
    fill: "#ce6f3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11241-3",
    "data-name": "Path 11241",
    d: "M-2.2-16.509.465-13.824a2.359,2.359,0,0,1,.863,1.474,2.32,2.32,0,0,1-.863,1.462A2.366,2.366,0,0,1-1-10.036,2.357,2.357,0,0,1-2.46-10.9L-5.1-13.56-7.758-10.9a2.356,2.356,0,0,1-1.45.863,2.4,2.4,0,0,1-1.462-.851,2.312,2.312,0,0,1-.875-1.462,2.359,2.359,0,0,1,.863-1.474l2.661-2.685-2.661-2.685a2.359,2.359,0,0,1-.863-1.474,2.351,2.351,0,0,1,.875-1.474,2.4,2.4,0,0,1,1.462-.863,2.356,2.356,0,0,1,1.45.863L-5.1-19.457l2.637-2.685A2.357,2.357,0,0,1-1-23.005a2.357,2.357,0,0,1,1.462.863,2.359,2.359,0,0,1,.863,1.474,2.359,2.359,0,0,1-.863,1.474Z",
    transform: "translate(22.066 33.478)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "number_9",
    transform: "translate(257 977)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "ellipse_9",
    cx: 33,
    cy: 33,
    r: 33,
    stroke: "#51aabc",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "number_9-2",
    "data-name": "number_9",
    d: "M-10.455-20.828A9.143,9.143,0,0,1-7.5-27.757,10.066,10.066,0,0,1-.328-30.545q5.371,0,8.077,3.424a13.82,13.82,0,0,1,2.706,8.835A19.585,19.585,0,0,1,6.027-5.207Q1.6.041-6.068.041h-.246a4.4,4.4,0,0,1-2.214-.41q-1.148-.7-1.148-3.239,0-2.87,1.558-3.362A7.979,7.979,0,0,1-5.74-7.216,9.466,9.466,0,0,0-2.48-7.79,6.947,6.947,0,0,0-.041-9.184a8.615,8.615,0,0,0,2.255-3.034l.2-.574a7.488,7.488,0,0,1-3.075.7A9.8,9.8,0,0,1-7.57-14.778a8.094,8.094,0,0,1-2.885-6.05ZM-.164-23.821q-3.157,0-3.157,2.747A2.633,2.633,0,0,0-2.6-19.311a2.93,2.93,0,0,0,2.316.82,3.525,3.525,0,0,0,2.44-.758A2.112,2.112,0,0,0,3-20.766a5.385,5.385,0,0,0-.1-1.189,2.912,2.912,0,0,0-.43-.923Q1.845-23.821-.164-23.821Z",
    transform: "translate(33 48)",
    fill: "#51aabc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "padlock_9",
    d: "M30.691,15.688H28.639V11.695a8.209,8.209,0,1,0-16.417-.111v4.1H10.17A3.43,3.43,0,0,0,6.75,19.1v16.42a3.43,3.43,0,0,0,3.42,3.42H30.691a3.43,3.43,0,0,0,3.42-3.42V19.108a3.43,3.43,0,0,0-3.42-3.42Zm-9.063,10.67v5.883a1.226,1.226,0,0,1-1.137,1.231,1.2,1.2,0,0,1-1.257-1.2V26.358a2.736,2.736,0,1,1,2.394,0Zm4.617-10.671H14.616v-4.1a5.814,5.814,0,1,1,11.628,0Z",
    transform: "translate(12.569 11.841)",
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SUCCESS_9",
    transform: "translate(48.543 -3.457)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_41-7",
    "data-name": "Ellipse 41",
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    transform: "translate(0.457 0.457)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "star_5_4",
    "data-name": "star (5)",
    d: "M24.359,9.81a1.311,1.311,0,0,0-1.117-.94L16.192,8.2,13.4,1.322a1.273,1.273,0,0,0-2.387,0L8.23,8.2l-7.05.674a1.314,1.314,0,0,0-1.116.94,1.414,1.414,0,0,0,.38,1.453l5.328,4.923L4.2,23.476a1.4,1.4,0,0,0,.5,1.412,1.236,1.236,0,0,0,1.426.066l6.08-3.828,6.078,3.828a1.239,1.239,0,0,0,1.427-.066,1.406,1.406,0,0,0,.5-1.412L18.65,16.185l5.328-4.922A1.416,1.416,0,0,0,24.359,9.81Zm0,0",
    transform: "translate(4.746 4.137)",
    fill: "#f5bd3f",
    opacity: 0.998
  })), /*#__PURE__*/React.createElement("g", {
    id: "FAIL_9",
    transform: "translate(48.543 -3.457)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_41-8",
    "data-name": "Ellipse 41",
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    transform: "translate(0.457 0.457)",
    fill: "#ce6f3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11241-4",
    "data-name": "Path 11241",
    d: "M-2.2-16.509.465-13.824a2.359,2.359,0,0,1,.863,1.474,2.32,2.32,0,0,1-.863,1.462A2.366,2.366,0,0,1-1-10.036,2.357,2.357,0,0,1-2.46-10.9L-5.1-13.56-7.758-10.9a2.356,2.356,0,0,1-1.45.863,2.4,2.4,0,0,1-1.462-.851,2.312,2.312,0,0,1-.875-1.462,2.359,2.359,0,0,1,.863-1.474l2.661-2.685-2.661-2.685a2.359,2.359,0,0,1-.863-1.474,2.351,2.351,0,0,1,.875-1.474,2.4,2.4,0,0,1,1.462-.863,2.356,2.356,0,0,1,1.45.863L-5.1-19.457l2.637-2.685A2.357,2.357,0,0,1-1-23.005a2.357,2.357,0,0,1,1.462.863,2.359,2.359,0,0,1,.863,1.474,2.359,2.359,0,0,1-.863,1.474Z",
    transform: "translate(22.066 33.478)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterfaceNumberPad);
export default __webpack_public_path__ + "static/media/interface_number_pad.f6b3416e.svg";
export { ForwardRef as ReactComponent };